<template>
  <v-form v-if="dialog" v-model="valid" ref="form">
    <v-dialog v-model="dialog" persistent scrollable width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Relatório de Durações de Parcerias
        </v-card-title>
        <v-card-text>
          <v-layout wrap justify-left align-center>
            <v-flex xs12>
              <v-flex xs12>
                <v-text-field v-if="editedItem.selectedConnection" ref="connectionIllis" disabled
                 :label="translate('table.connections.title')[0]" :value="editedItem.id_text">
                </v-text-field>
                <p-select-multiple
                  style="overflow: auto;"
                  v-else :loading="loading" :label="translate('table.connections.title')[0]" :readonly="loading" :filter="filterAutocomplete"
                  :rules="requiredRule(translate('table.connections.title')[0])"  v-model="editedItem.connections" :items="itemsConnections" item_text="id_text" item_value="id"
                ></p-select-multiple>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm6>
              <p-select-multiple
                style="overflow: auto;"
                :loading="loading" :label="translate('table.teams.title')[0]" :readonly="loading" :filter="filterAutocomplete"
                :rules="requiredRule(translate('table.teams.title')[0])"  v-model="editedItem.teams" :items="itemsTeams" item_text="id_text" item_value="id"
              ></p-select-multiple>
            </v-flex>
            <v-flex xs12 sm6>
              <p-select-multiple
                style="overflow: auto;"
                :loading="loading" :label="translate('table.task_category.title')[0]" :readonly="loading" :filter="filterAutocomplete"
                :rules="requiredRule(translate('table.task_category.title')[0])"  v-model="editedItem.categories" :items="itemsCategories" item_text="id_text" item_value="id"
              ></p-select-multiple>
            </v-flex>
            <v-flex xs12 sm6>
              <p-date-time :label="translate('table.' + entity + '.field.begin')"
                           v-model="editedItem.begin"
                           :defaultHour="'00:00'"
                           :rules="dateDiffRule()"
                           :disabled="!checkPlanAccess('reports_everyday', 'has')"
                           >
              </p-date-time>
            </v-flex>
            <v-flex xs12 sm6>
              <p-date-time :label="translate('table.' + entity + '.field.end')"
                           v-model="editedItem.end"
                           :defaultHour="'23:59'"
                           :rules="dateDiffRule()"
                           :disabled="!checkPlanAccess('reports_everyday', 'has')"
                           >
              </p-date-time>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" class="mx-1" color="primary darken-1" @click='openReport(1)'>PDF</v-btn>
          <v-btn :loading="loading" class="mx-1" color="primary darken-2" @click='openReport(2)'>Excel</v-btn>
          <v-btn class="mx-1" @click="close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
  import rules from './../../mixin/rules'
  import plan from './../../mixin/plan'
  import PDateTime from './../shared/PDateTime'
  import PDate from './../shared/PDate'
  import PSelectMultiple from './../shared/PSelectMultiple'

  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'

  momentDurationFormatSetup(moment)
  export default {
    mixins: [rules, plan],
    name: 'PConnectionDuration',
    components: {
      PDateTime,
      PDate,
      PSelectMultiple
    },
    data: () => ({
      itemsConnections: [],
      itemsTeams: [],
      itemsCategories: [],
      valid: false,
      editedItem: {connections: [], teams: [], categories: [], begin: '', end: '', id_text: '', selectedConnection: false},
      defaultItem: {connections: [], teams: [], categories: [], begin: '', end: '', id_text: '', selectedConnection: false},
      entity: 'task_duration',
      permission: false,
      dialog: false,
      loading: true
    }),
    props: {},
    methods: {
      openReport: function (type) {
        if (!this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          })
          return false
        }
        let params = ''
        if (this.editedItem.connections.length > 0) {
          params = `connections=${JSON.stringify(this.editedItem.connections)}`
        }
        if (this.editedItem.teams.length > 0) {
          params = params + `&teams=${JSON.stringify(this.editedItem.teams)}`
        }
        if (this.editedItem.categories.length > 0) {
          params = params + `&categories=${JSON.stringify(this.editedItem.categories)}`
        }
        if (this.editedItem.begin !== '') {
          params = params + '&begin=' + this.editedItem.begin
        }
        if (this.editedItem.end !== '') {
          params = params + '&end=' + this.editedItem.end
        }
        if (type === 1) {
          params = params + '&type=' + 1
        } else {
          params = params + '&type=' + 2
        }
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        this.$http.get(`api/report/connection/duration?${params}`).then(res => {
          let fileName = res.bodyText
          window.open(process.env.API + 'uploads/reports/' + fileName, '_blank')
          let _this = this
          setTimeout(function () {
            _this.$http.delete(`api/delete_upload_report/${fileName}`)
          }, 5000)
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        }, (err) => {
          if (err.body.message === 'accessDenied') {
            this.$store.commit('snackbar/change_values', {timeout: 12000, text: 'Você não possui acesso para esse relatório.', color: 'warning', dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível abrir esse relatório, reporte o erro.', color: 'error', dialog: true})
            alert('Erro! Falha ao enviar a requisição.')
          }
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        })
      },
      openDialog: function (connectionId = '', idText = '') {
        this.loading = true
        this.dialog = true
        this.editedItem.begin = moment().format('YYYY-MM-DD 00:00')
        this.editedItem.end = moment().format('YYYY-MM-DD 23:59')
        this.$http.get('api/report_connection_filters').then(res => {
          this.itemsCategories = res.body['categories']
          this.itemsTeams = res.body['teams']
          this.loading = false
          if (connectionId !== '') {
            this.editedItem.connections = [connectionId]
            this.editedItem.id_text = idText
            this.editedItem.selectedConnection = true
            this.loading = false
          } else {
            this.itemsConnections = res.body['connections']
          }
        }, err => {
          console.log(err, 'err')
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros, reporte o erro.', color: 'error', dialog: true})
          this.loading = false
        })
      },
      filterAutocomplete  (item, queryText, itemText) {
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(query) > -1
      },
      close: function () {
        this.dialog = false
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.defaultItem)))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/reports/PConnectionDuration.vue